import "core-js/modules/es6.array.index-of";
import { updateTransactionsViewList, recategorizeMerchant, recategorizeTransaction, deleteMerchantTag, createMerchantTag, getTransactionsBulkStart, editTransaction } from "../actions/yodlee";
var middlewareActions = [recategorizeMerchant.SUCCESS_TYPE, createMerchantTag.SUCCESS_TYPE, deleteMerchantTag.SUCCESS_TYPE, recategorizeTransaction.SUCCESS_TYPE, editTransaction.SUCCESS_TYPE];
export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      var result = next(action);

      if (middlewareActions.indexOf(action.type) === -1) {
        return result;
      }

      var _getState$identity$yo = getState().identity.yodlee.transactions,
          viewFilter = _getState$identity$yo.viewFilter,
          viewList = _getState$identity$yo.viewList;

      switch (action.type) {
        case recategorizeMerchant.SUCCESS_TYPE:
        case recategorizeTransaction.SUCCESS_TYPE:
        case editTransaction.SUCCESS_TYPE:
          if (viewFilter.category === action.meta.category) {
            // Need to refetch all transactions and update view list when done
            dispatch(getTransactionsBulkStart(viewList.length, viewFilter));
          }

          dispatch(updateTransactionsViewList(viewList.length));
          break;

        case createMerchantTag.SUCCESS_TYPE:
          if (viewFilter.tag === action.meta.tag) {
            // Need to refetch all transactions and update view list when done
            dispatch(getTransactionsBulkStart(viewList.length, viewFilter));
          }

          dispatch(updateTransactionsViewList(viewList.length));
          break;

        default:
          dispatch(updateTransactionsViewList(viewList.length));
          break;
      }

      return result;
    };
  };
});